import type { Video } from "./types";

export const videos: Video[] = [
  {
    id: "v1",
    title: "流浪地球3：星际远征",
    description: "在太阳即将毁灭的危机下，人类团结一致，开启了前所未有的星际远征计划。本片延续前作宏大的宇宙叙事，以震撼的视觉特效和深刻的人文关怀，展现人类在绝境中迸发的勇气与智慧。新一代宇航员们将面临更加艰难的抉择，家园与远方，生存与牺牲，一切答案都指向浩瀚星空。影片由原班人马打造，特效全面升级，IMAX拍摄带来极致沉浸体验。",
    category: "movie",
    thumbnail: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20scene%20with%20space%20station%20and%20astronauts%20in%20futuristic%20suits%20looking%20at%20distant%20galaxy%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20clean%20professional%20movie%20poster%20style%20with%20deep%20space%20background&width=800&height=450&seq=thumb-v1&orientation=landscape",
    duration: "128分钟",
    views: 1580000,
    rating: 9.2,
    tags: ["科幻", "冒险", "太空", "IMAX"],
    publishDate: "2026-07-15",
    featured: true,
  },
  {
    id: "v2",
    title: "长安十二时辰：盛世风云",
    description: "盛唐长安，万国来朝。十二个时辰内，一场关乎帝国命运的惊天阴谋正在展开。本剧以极致考究的服化道和扣人心弦的剧情，再现大唐盛世的繁华与危机。每位角色都深陷命运漩涡，在忠诚与背叛、大义与私情之间做出抉择。",
    category: "tv",
    thumbnail: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20palace%20scene%20with%20traditional%20architecture%20lanterns%20and%20costumes%2C%20cinematic%20warm%20golden%20lighting%2C%20epic%20historical%20drama%20aesthetic%2C%20clean%20composition&width=800&height=450&seq=thumb-v2&orientation=landscape",
    duration: "48集",
    views: 2350000,
    rating: 9.5,
    tags: ["古装", "悬疑", "历史", "剧情"],
    publishDate: "2026-06-20",
    featured: true,
  },
  {
    id: "v3",
    title: "深海迷踪：蓝色星球探秘",
    description: "跟随国际顶尖海洋生物学家团队，深入世界各大洋最神秘的海域。从马里亚纳海沟到百慕大三角，从未被探索的深海洞穴到绚丽多彩的珊瑚礁，本片以4K超高清画质记录下前所未见的海洋奇观和珍稀生物。",
    category: "documentary",
    thumbnail: "https://readdy.ai/api/search-image?query=Underwater%20ocean%20documentary%20scene%20with%20colorful%20coral%20reef%20and%20exotic%20fish%2C%20crystal%20clear%20blue%20water%2C%20sunlight%20rays%20penetrating%20ocean%20surface%2C%20professional%20underwater%20photography%20style&width=800&height=450&seq=thumb-v3&orientation=landscape",
    duration: "96分钟",
    views: 892000,
    rating: 9.4,
    tags: ["自然", "海洋", "4K", "探索"],
    publishDate: "2026-06-01",
    featured: true,
  },
  {
    id: "v4",
    title: "欢乐喜剧人：爆笑全明星",
    description: "国内顶尖喜剧人集结，带来全新一季的爆笑盛宴。本季节目采用全新赛制，加入即兴挑战和跨界合作环节，让喜剧碰撞出更精彩的火花。邀你一起开怀大笑，释放压力。",
    category: "variety",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20variety%20show%20stage%20with%20bright%20colorful%20lights%20and%20performers%2C%20entertaining%20atmosphere%2C%20warm%20stage%20lighting%2C%20professional%20show%20photography&width=800&height=450&seq=thumb-v4&orientation=landscape",
    duration: "12期",
    views: 1200000,
    rating: 8.9,
    tags: ["喜剧", "综艺", "搞笑", "明星"],
    publishDate: "2026-05-10",
    featured: false,
  },
  {
    id: "v5",
    title: "剑灵传说：苍穹之战",
    description: "少年剑客林逸自幼失去双亲，被神秘高人收养，习得绝世剑法。为寻仇人和身世之谜，他踏上了一条充满危险与奇遇的修真之路。东方玄幻与热血战斗的完美结合，每一帧都是壁纸级别的精美画面。",
    category: "anime",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20anime%20martial%20arts%20fantasy%20scene%20with%20swordsman%20on%20mountain%20peak%20under%20moonlight%2C%20flowing%20robes%2C%20dynamic%20action%20pose%2C%20beautiful%20ink%20wash%20painting%20style%20with%20dramatic%20lighting&width=800&height=450&seq=thumb-v5&orientation=landscape",
    duration: "52集",
    views: 1890000,
    rating: 9.1,
    tags: ["国漫", "玄幻", "热血", "武侠"],
    publishDate: "2026-04-22",
    featured: true,
  },
  {
    id: "v6",
    title: "NBA总决赛：巅峰对决2026",
    description: "2026年NBA总决赛完整回顾，见证篮球历史上最激动人心的七场大战。从常规赛的激烈厮杀到季后赛的步步惊心，最终两支顶级球队在总决赛的舞台上展开巅峰对决。高清画质，专业解说，带你重温每一个精彩瞬间。",
    category: "sports",
    thumbnail: "https://readdy.ai/api/search-image?query=Professional%20basketball%20NBA%20finals%20game%20scene%20with%20players%20in%20action%20on%20court%2C%20dramatic%20arena%20lighting%2C%20excited%20crowd%20background%2C%20sports%20photography%20style%20with%20dynamic%20motion&width=800&height=450&seq=thumb-v6&orientation=landscape",
    duration: "150分钟",
    views: 3200000,
    rating: 9.6,
    tags: ["篮球", "NBA", "体育", "决赛"],
    publishDate: "2026-07-01",
    featured: true,
  },
  {
    id: "v7",
    title: "荒野求生：极地极限挑战",
    description: "世界顶级生存专家深入北极圈，在零下50度的极端环境中挑战人类生存极限。没有食物、没有庇护所，只有最原始的求生技能和永不放弃的意志。每一集都是一场与死神的博弈，真实记录人类在极端自然环境下的顽强生命力。",
    category: "documentary",
    thumbnail: "https://readdy.ai/api/search-image?query=Extreme%20arctic%20wilderness%20survival%20scene%20with%20snowy%20mountains%20and%20frozen%20landscape%2C%20lonely%20explorer%20in%20heavy%20winter%20gear%2C%20dramatic%20cold%20atmosphere%2C%20cinematic%20documentary%20photography&width=800&height=450&seq=thumb-v7&orientation=landscape",
    duration: "60分钟",
    views: 678000,
    rating: 9.3,
    tags: ["冒险", "求生", "极地", "自然"],
    publishDate: "2026-03-18",
    featured: false,
  },
  {
    id: "v8",
    title: "电竞巅峰：LPL春季赛回顾",
    description: "2026年LPL春季赛全程精彩回顾，带你重温每一个高光时刻。从常规赛的群雄逐鹿到季后赛的巅峰对决，中国顶级电竞战队用实力诠释了什么是不屈的电竞精神。专业赛事分析、选手独家采访，全方位呈现这场电竞盛宴。",
    category: "game",
    thumbnail: "https://readdy.ai/api/search-image?query=E-sports%20arena%20with%20large%20screens%20displaying%20game%20and%20excited%20crowd%2C%20professional%20gaming%20stage%20with%20colorful%20LED%20lights%2C%20dynamic%20esports%20event%20photography&width=800&height=450&seq=thumb-v8&orientation=landscape",
    duration: "85分钟",
    views: 2100000,
    rating: 9.0,
    tags: ["电竞", "LPL", "英雄联盟", "赛事"],
    publishDate: "2026-05-28",
    featured: false,
  },
  {
    id: "v9",
    title: "华语金曲盛典：经典永流传",
    description: "汇聚华语乐坛顶级歌手，演绎跨越时代的经典金曲。从80年代的怀旧老歌到当下最热流行单曲，每一首歌都承载着无数人的青春记忆。顶级音响设备和舞台灯光，打造视听双重盛宴。",
    category: "music",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20music%20awards%20ceremony%20stage%20with%20singer%20performing%20under%20dramatic%20spotlight%2C%20elegant%20stage%20design%20with%20golden%20and%20warm%20tones%2C%20professional%20concert%20photography&width=800&height=450&seq=thumb-v9&orientation=landscape",
    duration: "120分钟",
    views: 1560000,
    rating: 9.3,
    tags: ["音乐", "演唱会", "华语", "经典"],
    publishDate: "2026-04-05",
    featured: true,
  },
  {
    id: "v10",
    title: "美食之旅：寻味中国",
    description: "跟随知名美食家走遍中国大江南北，探寻最地道的地方美食。从四川的麻辣火锅到广东的精致早茶，从新疆的烤全羊到江南的精致小点，每一道美食背后都有着动人的故事和独特的文化传承。",
    category: "variety",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20scene%20with%20colorful%20traditional%20dishes%20on%20wooden%20table%2C%20steaming%20hot%20food%20in%20warm%20restaurant%20setting%2C%20appetizing%20food%20photography%20with%20natural%20lighting&width=800&height=450&seq=thumb-v10&orientation=landscape",
    duration: "24集",
    views: 1980000,
    rating: 9.4,
    tags: ["美食", "旅游", "文化", "纪录片"],
    publishDate: "2026-02-14",
    featured: false,
  },
  {
    id: "v11",
    title: "黑客帝国：觉醒",
    description: "在虚拟与现实的边界日益模糊的未来，一名普通程序员意外发现了世界的真相。矩阵再次升级，新的救世主必须面对更加复杂的抉择。震撼的视觉革命，哲学深度的科幻巨制，重新定义动作电影的可能性。",
    category: "movie",
    thumbnail: "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20scene%20with%20digital%20matrix%20code%20rain%20and%20cyberpunk%20city%20background%2C%20dark%20green%20tinted%20lighting%2C%20mysterious%20atmosphere%2C%20cinematic%20film%20poster%20style&width=800&height=450&seq=thumb-v11&orientation=landscape",
    duration: "145分钟",
    views: 2750000,
    rating: 9.0,
    tags: ["科幻", "动作", "赛博朋克", "哲学"],
    publishDate: "2026-07-28",
    featured: true,
  },
  {
    id: "v12",
    title: "鬼灭之刃：无限城篇",
    description: "炭治郎与伙伴们终于闯入鬼舞辻无惨的最终据点——无限城。在这座扭曲的异度空间里，柱与上弦之鬼的最终决战正式打响。极致的战斗演出，感人至深的角色故事，为这场持续多年的冒险画上壮丽句号。",
    category: "anime",
    thumbnail: "https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20demon%20slayer%20battle%20scene%20with%20flame%20effects%20and%20dynamic%20sword%20action%2C%20dark%20mysterious%20castle%20interior%2C%20intense%20dramatic%20lighting%2C%20anime%20art%20style&width=800&height=450&seq=thumb-v12&orientation=landscape",
    duration: "118分钟",
    views: 4100000,
    rating: 9.7,
    tags: ["日漫", "热血", "战斗", "剧场版"],
    publishDate: "2026-08-01",
    featured: true,
  },
];